import { render, staticRenderFns } from "./ConfirmationDialogVideoEmbed.vue?vue&type=template&id=807b9c36"
import script from "./ConfirmationDialogVideoEmbed.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogVideoEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports